import React, { useEffect, useState } from 'react';
import "../styles/popupstyles/productspopup.css";
import ProdImgPopup from './ProdImgPopup';


function ProductsPopup({ product, onClose }) {
  const [showImagePopup, setShowImagePopup] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('products-popup-overlay')) {
      onClose();
    }
  };

  const handleImageClick = (e) => {
    e.stopPropagation();
    setShowImagePopup(true);
  };

  const handleCloseImagePopup = () => {
    setShowImagePopup(false);
  };

  return (
    <>
      <div className="products-popup-overlay" onClick={handleOverlayClick}>
        <div className="products-popup-container">
          <button className="products-popup-close" onClick={onClose}>
            ×
          </button>
          
          <div className="products-popup-content">
            <div 
              className="products-popup-image" 
              onClick={handleImageClick}
            >
              <img src={product.image} alt={product.name} />
              <div className="image-hover-indicator">
                <div className="indicator-icon">🔍View Gallery</div>
              </div>
            </div>
            
            <div className="products-popup-details">
              <h2 className="products-popup-title">{product.name}</h2>
              <p className="products-popup-description">{product.description}</p>
              
              <div className="products-popup-specs">
                <h3>Technical Specifications</h3>
                <div className="specs-grid">
                  {Object.entries(product.specifications).map(([key, value], index) => (
                    <div key={index} className="spec-item">
                      <span className="spec-label">{key}</span>
                      <span className="spec-value">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showImagePopup && (
        // GALLERY BUG FIX:
        // Previous code used product.category — that property DOES NOT EXIST on the product object.
        // The correct field is product.categoryKey, which is set by the allProducts flatMap
        // in Products.jsx and passed through as a prop to ProductsPopup.
        // Bug result: category was undefined → galleryAssets received empty string
        // → path resolved to assets/prodgallery//truuna/ (double slash) → no assets found.
        // Fix: use product.categoryKey consistently across the entire data flow.
        <ProdImgPopup 
          productName={product.name}
          category={product.categoryKey}
          productKey={product.productKey}
          onClose={handleCloseImagePopup} 
        />
      )}
    </>
  );
}

export default ProductsPopup;